
<template>
  <div class="global-tabbar">
    <div class="tabbar-container">
      <div class="tabbar-backdrop"></div>
      <div class="tabbar-content">
        <div
          v-for="item in tabItems"
          :key="item.name"
          class="tab-item"
          :class="{'tab-active': route.path === item.path }"
          @click="navigateTo(item.path)"
         >
          <div class="tab-icon-wrapper">
            <img class="tab-icon" :src="item.icon" >
          </div>
          <span class="tab-text">{{ t(item.label) }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import homeIcon from '@/assets/static/footer/login.jpg'
import purchaseIcon from '@/assets/static/footer/order.png'
import grabbingIcon from '@/assets/static/footer/PlaceOrder.png'
import KefuIcon from '@/assets/static/footer/kefu.png'
import myIcon from '@/assets/static/footer/my.png'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const tabItems = [
  { name: 'Home', icon: homeIcon, label: 'tabbar.home', path: '/' },
  { name: 'Purchase', icon: purchaseIcon, label: 'tabbar.purchase', path: '/purchase' },
  { name: 'Grabbing', icon: grabbingIcon, label: 'tabbar.grabbing', path: '/grabbing' },
  { name: 'Kefu', icon: KefuIcon, label: 'tabbar.kefu', path: '/kefu' },
  { name: 'My', icon: myIcon, label: 'tabbar.my', path: '/my' }
]

const navigateTo = (path) => {
  router.push(path)
}
</script>


